import graphQLClient from 'config/graphql-instance';
import { gql } from 'graphql-request';

type instructions = {
  accounting_id: string;
  amount: number;
  association_id: string;
  payment_id: string;
};

export const createTransferRequest = async (payload: {
  orderId: string;
  authorization: string[];
  instructions: instructions[];
}) => {
  const mutation = gql`
    mutation CreateTransferRequest(
      $orderId: String!
      $authorization: [String!]!
      $instructions: [TransferInstructionContent!]!
    ) {
      createTransferRequest(
        order_id: $orderId
        authorization: $authorization
        instructions: $instructions
      )
    }
  `;

  const response = await graphQLClient().request(mutation, payload);

  return response;
};

export const authorizeTransferRequest = async (payload: {
  orderId: string;
  reference: string;
  action: string;
}) => {
  const mutation = gql`
    mutation CreateTransferRequest(
      $orderId: String!
      $reference: String!
      $action: TransferAuthorizeAction!
    ) {
      authorizeTransferRequest(order_id: $orderId, reference: $reference, action: $action)
    }
  `;

  const response = await graphQLClient().request(mutation, payload);

  return response;
};

export type GQLDeletePartyPayment = {
  deletePartyPayment: {
    _id: string;
  };
};

export const deletePartyPayment = async (payload: { partyId: string; paymentId: string }) => {
  const mutation = gql`
    mutation DeletePartyPayment($partyId: ID!, $paymentId: ID!) {
      deletePartyPayment(_id: $partyId, payment_id: $paymentId) {
        _id
      }
    }
  `;

  const response = await graphQLClient().request<GQLDeletePartyPayment>(mutation, payload);

  return response;
};

export type GQLCreatePartyPayment = {
  createPartyPayment: {
    _id: string;
  };
};

export type GQLCreatePartyPaymentPayload = {
  partyId: string;
  dataWire: {
    account: string;
    bank: string;
    bank_address: string;
    country: string;
    name: string;
    routing: string;
  };
};

export const createPartyPayment = async (payload: GQLCreatePartyPaymentPayload) => {
  const mutation = gql`
    mutation CreatePartyPayment($partyId: ID!, $dataWire: PartyPaymentWireContent) {
      createPartyPayment(_id: $partyId, data_wire: $dataWire) {
        _id
      }
    }
  `;

  const response = await graphQLClient().request<GQLCreatePartyPayment>(mutation, payload);

  return response;
};
